import { useTranslation } from "react-i18next";

export type NameByLangItem =
  | ({} & {
      name?: string | { ar?: string; en?: string };
      nameAr?: string;
      nameEn?: string;
      nickName?: string;
      title?: string;
      titleAr?: string;
      titleEn?: string;
      filename?: string;
      value?: string;
      name_ar?: string;
      name_en?: string;
      en?: string;
      ar?: string;
      status_ar?: string;
      status_en?: string;
      label?: string | { ar?: string; en?: string };
    })
  | null
  | undefined;

type Props = {
  item: NameByLangItem;
};

export const getNameByLang = (item: NameByLangItem, language: "en" | "ar") => {
  if (!item) return undefined;

  const fieldsEn = [
    "nameEn",
    "titleEn",
    "name_en",
    "nickName",
    "title",
    "filename",
    "status_en",
    "value",
    "en",
    "name",
    "label",
  ];

  const fieldsAr = [
    "nameAr",
    "titleAr",
    "name_ar",
    "nickName",
    "title",
    "filename",
    "status_ar",
    "value",
    "ar",
    "name",
    "label",
  ];

  const fields = language === "en" ? fieldsEn : fieldsAr;

  for (const field of fields) {
    const val = (item as any)[field];
    if (val !== undefined && val !== null && val !== "") {
      const processed =
        typeof val === "object" && val !== null ? val[language] : val;
      if (
        processed !== undefined &&
        processed !== null &&
        typeof processed !== "object"
      ) {
        return processed;
      }
    }
  }

  return undefined;
};

export const NameByLang = ({ item }: Props) => {
  const { i18n } = useTranslation();
  const value = getNameByLang(item, i18n.language === "en" ? "en" : "ar");

  if (value !== undefined && value !== null) return <>{value}</>;
  return <>-</>;
};
